// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 15px 15px 0px 15px;
  margin-top: 10px;
}
.card .cardTitle {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
}

.table-header {
  border-bottom: 2px solid var(--color-primary);
  font-style: normal;
  font-size: 14px;
}

.table thead th {
  font-weight: 400;
}

.header-title {
  color: var(--color-interaction-text);
}

.table-content {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

.tech-support-container {
  display: flex;
  align-items: center;
  padding-bottom: 5px;
}

.tech-support-header {
  font-weight: bold;
}

.tech-support-question {
  padding: 5px 0;
}

.tech-support-options {
  display: flex;
  flex-direction: row;
}

.tech-support-options .btn.focus, .tech-support-options .btn:focus {
  outline: 0;
  box-shadow: none !important;
}

.restart-btn {
  margin: 10px;
  line-height: 1.3;
  font-size: 14px;
}

.restart-btn.focus, .restart-btn:focus {
  outline: 0;
  box-shadow: none !important;
}

.assessment-info {
  text-align: center;
  padding: 5px 0;
}

.faq-url {
  margin-top: 5px;
  margin-bottom: 2px;
}

.tech-support-buttons {
  line-height: 1;
  font-size: 14px;
}

.highlighted {
  border: 2px solid var(--color-primary);
}

.m-screen-header-wrapper {
  position: relative;
  z-index: 100;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/tech-support/tech-support.component.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,gBAAA;AACJ;AACI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AACN;;AAGA;EACI,6CAAA;EACA,kBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,oCAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;AAAJ;;AAII;EACI,UAAA;EACA,2BAAA;AADR;;AAKA;EACI,YAAA;EACA,gBAAA;EACA,eAAA;AAFJ;;AAKA;EACI,UAAA;EACA,2BAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,eAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,cAAA;EACA,eAAA;AAFJ;;AAKA;EACI,sCAAA;AAFJ;;AAKA;EACE,kBAAA;EACA,YAAA;AAFF","sourcesContent":[".card {\n    padding: 15px 15px 0px 15px;\n    margin-top: 10px;\n\n    .cardTitle {\n      font-style: normal;\n      font-weight: 600;\n      font-size: 18px;\n    }\n}\n\n.table-header {\n    border-bottom: 2px solid var(--color-primary);\n    font-style: normal;\n    font-size: 14px;\n}\n\n.table thead th {\n    font-weight: 400;\n}\n\n.header-title {\n    color: var(--color-interaction-text);\n}\n\n.table-content {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n}\n\n.tech-support-container {\n    display: flex;\n    align-items: center;\n    padding-bottom: 5px;\n}\n\n.tech-support-header {\n    font-weight: bold;\n}\n\n.tech-support-question {\n    padding: 5px 0;\n}\n\n.tech-support-options {\n    display: flex;\n    flex-direction: row;\n}\n\n.tech-support-options {\n    .btn.focus, .btn:focus {\n        outline: 0;\n        box-shadow: none !important;\n    }\n}\n\n.restart-btn {\n    margin: 10px;\n    line-height: 1.3;\n    font-size: 14px;\n}\n\n.restart-btn.focus, .restart-btn:focus {\n    outline: 0;\n    box-shadow: none !important;\n}\n\n.assessment-info {\n    text-align: center;\n    padding: 5px 0;\n}\n\n.faq-url{\n    margin-top:5px;\n    margin-bottom: 2px;\n}\n\n.tech-support-buttons{\n    line-height: 1;\n    font-size: 14px;\n}\n\n.highlighted{\n    border: 2px solid var(--color-primary);\n}\n\n.m-screen-header-wrapper {\n  position: relative;\n  z-index: 100;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
